var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isShow
    ? _c("section", [
        _c(
          "h2",
          {
            staticClass: "card__title card__title--small",
            class: _vm.$style.listTitle,
          },
          [_vm._v(" 個人資料 ")]
        ),
        _c("ul", { staticClass: "list" }, [
          _c("li", { staticClass: "list__item item" }, [
            _c("span", { staticClass: "title" }, [_vm._v("姓名")]),
            _c("span", { staticClass: "data" }, [
              _vm._v(
                _vm._s(_vm.memberContactData.contactLastName) +
                  " " +
                  _vm._s(_vm.memberContactData.contactFirstName)
              ),
            ]),
          ]),
          _c("li", { staticClass: "list__item" }, [
            _c("span", { staticClass: "title" }, [_vm._v("聯絡電話")]),
            _c("span", { staticClass: "data" }, [
              _vm._v(_vm._s(_vm.memberContactData.contactPhone)),
            ]),
          ]),
          _c("li", { staticClass: "list__item" }, [
            _c("span", { staticClass: "title" }, [_vm._v("電子信箱")]),
            _c("span", { staticClass: "data" }, [
              _vm._v(
                _vm._s(
                  _vm.memberContactData.contactEmail ||
                    _vm.memberContactData.loginAccountEmail
                )
              ),
            ]),
          ]),
          _c("li", { staticClass: "list__item" }, [
            _c("span", { staticClass: "title" }, [_vm._v("收據寄送地址")]),
            _c("span", { staticClass: "data" }, [
              _vm._v(_vm._s(_vm.memberContactData.contactHomeAddress)),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }